<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import CardLayout from 'dashboard/components-next/CardLayout.vue';

const props = defineProps({
  excerpt: {
    type: String,
    default: '',
  },
  origin: {
    type: String,
    default: 'written',
  },
  state: {
    type: String,
    default: 'preparing',
  },
});

const { t } = useI18n();

const originLabel = computed(() =>
  props.origin === 'pdf'
    ? t('ONIX.KNOWLEDGE.ORIGIN_PDF')
    : t('ONIX.KNOWLEDGE.ORIGIN_WRITTEN')
);

const stateLabel = computed(() => {
  if (props.state === 'ready') return t('ONIX.KNOWLEDGE.STATE_READY');
  if (props.state === 'failed') return t('ONIX.KNOWLEDGE.STATE_FAILED');
  return t('ONIX.KNOWLEDGE.STATE_PREPARING');
});

const stateClass = computed(() => {
  if (props.state === 'ready') return 'text-n-teal-11 bg-n-teal-3';
  if (props.state === 'failed') return 'text-n-ruby-11 bg-n-ruby-3';
  return 'text-n-amber-11 bg-n-amber-3';
});
</script>

<template>
  <CardLayout>
    <p class="m-0 text-sm text-n-slate-12 whitespace-pre-wrap">
      {{ excerpt }}
    </p>
    <div class="flex items-center gap-2">
      <span class="text-xs text-n-slate-11">{{ originLabel }}</span>
      <span class="text-xs px-2 py-0.5 rounded-full" :class="stateClass">
        {{ stateLabel }}
      </span>
    </div>
  </CardLayout>
</template>
